module.exports = __webpack_public_path__ + "img/google_chrome.712c0a31.svg";